import { browserLogger } from './browser';

type LogGtmEventArgs = Parameters<typeof browserLogger>[0];

export const logGtmEvent = (
  eventName: string,
  eventData: Record<string, unknown>,
  team: LogGtmEventArgs['team'] = 'client-onboarding',
  level: LogGtmEventArgs['level'] = 'info',
) => {
  browserLogger({
    team,
    feature: 'gtm-events',
    level,
    message: 'CSGTM Event',
    context: {
      eventName,
      ...eventData,
    },
  });
};
